import { 
  collection, 
  doc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp 
} from 'firebase/firestore';
import { auth, db } from './firebase';

const getAuditActor = () => ({
  auditActorId: auth.currentUser?.uid || '',
  auditActorEmail: auth.currentUser?.email || '',
  auditActorName: auth.currentUser?.displayName || auth.currentUser?.email || ''
});

// Generic CRUD operations to reduce code duplication

export const createDocument = async (collectionPath, data) => {
  try {
    const docRef = await addDoc(collection(db, collectionPath), {
      ...data,
      ...getAuditActor(),
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return { id: docRef.id, error: null };
  } catch (error) {
    return { id: null, error: error.message };
  }
};

export const updateDocument = async (collectionPath, docId, data) => {
  try {
    await updateDoc(doc(db, collectionPath, docId), {
      ...data,
      ...getAuditActor(),
      updatedAt: serverTimestamp()
    });
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

export const deleteDocument = async (collectionPath, docId) => {
  try {
    const documentRef = doc(db, collectionPath, docId);
    await updateDoc(documentRef, getAuditActor());
    await deleteDoc(documentRef);
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

export const getDocument = async (collectionPath, docId) => {
  try {
    const docSnap = await getDoc(doc(db, collectionPath, docId));
    if (docSnap.exists()) {
      return { data: { id: docSnap.id, ...docSnap.data() }, error: null };
    }
    return { data: null, error: 'Document not found' };
  } catch (error) {
    return { data: null, error: error.message };
  }
};

export const queryDocuments = async (collectionPath, conditions = [], orderByField = null, limitCount = null) => {
  try {
    let q = collection(db, collectionPath);
    
    // Apply where conditions
    conditions.forEach(condition => {
      q = query(q, where(condition.field, condition.operator, condition.value));
    });
    
    // Apply ordering
    if (orderByField) {
      q = query(q, orderBy(orderByField.field, orderByField.direction || 'asc'));
    }
    
    // Apply limit
    if (limitCount) {
      q = query(q, limit(limitCount));
    }
    
    const querySnapshot = await getDocs(q);
    const documents = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    return { data: documents, error: null };
  } catch (error) {
    return { data: [], error: error.message };
  }
};
